const download = (url, name) => {
  if (!url) {
    alert("url이 없습니다.");
    return false;
  }
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const blobURL = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobURL;
      a.style.display = "none";
      if (name) a.download = name;
      document.body.appendChild(a);
      a.click();
    })
    .catch(() => {
      window.open(url, "_blank");
    });
};

const downExcelFile = (res, name) => {
  const blob = new Blob([res.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.style.display = "none";
  if (name) a.download = name;
  document.body.appendChild(a);
  a.click();
};

export { download, downExcelFile };
